(() => {
 const root = document.documentElement;
 const mobileLayout = matchMedia('(max-width: 649px)');
 const disclosures = [...document.querySelectorAll('[data-ic-desktop-disclosure]')];
 const syncDisclosures = () => disclosures.forEach(disclosure => {
  disclosure.open = !mobileLayout.matches;
  const summary = disclosure.querySelector('summary');
  if (mobileLayout.matches) summary.removeAttribute('tabindex');
  else summary.setAttribute('tabindex', '-1');
 });
 syncDisclosures();
 mobileLayout.addEventListener('change', syncDisclosures);
 const mobileMenu = document.querySelector('[data-ic-mobile-menu]');
 const profileLink = mobileMenu?.querySelector('a[href$="#profile-mobile"]');
 const syncProfileLink = () => {
  if (profileLink) profileLink.hash = mobileLayout.matches ? 'profile-mobile' : 'profile';
 };
 syncProfileLink();
 mobileLayout.addEventListener('change', syncProfileLink);
 const menuBreakpoint = matchMedia('(max-width: 899px)');
 const closeMenu = (restoreFocus = false) => {
  if (!mobileMenu?.open) return;
  mobileMenu.open = false;
  if (restoreFocus) mobileMenu.querySelector('summary').focus({ preventScroll: true });
 };
 document.addEventListener('keydown', event => { if (event.key === 'Escape') closeMenu(true); });
 document.addEventListener('click', event => {
  if (!mobileMenu?.contains(event.target) || event.target.closest('a')) closeMenu();
 });
 menuBreakpoint.addEventListener('change', () => { if (!menuBreakpoint.matches) closeMenu(); });
 const dialog = document.getElementById('ic-preorder');
 const scrollingSurface = window;
 const scrollPosition = () => window.scrollY;
 let opener = null;
 function close() { dialog?.close(); root.classList.remove('ic-lock'); opener?.focus(); }
 document.addEventListener('click', event => {
  const trigger = event.target.closest('[data-ic-preorder]');
  if (trigger && dialog?.showModal) {
   event.preventDefault(); opener = trigger; dialog.showModal(); root.classList.add('ic-lock');
   const focus = matchMedia('(pointer: fine)').matches ? dialog.querySelector('input[type="email"]') : dialog.querySelector('[data-ic-close]');
   focus?.focus({ preventScroll: true });
  }
  if (event.target.closest('[data-ic-close]')) close();
  const privacy = event.target.closest('[data-ic-privacy-settings]');
  if (privacy) { if (window.privacyBanner?.showPreferences) window.privacyBanner.showPreferences(); else if (privacy.dataset.fallback) location.assign(privacy.dataset.fallback); }
  const thumb = event.target.closest('[data-ic-gallery-src]');
  if (thumb) {
   const main = document.querySelector('[data-ic-gallery-image]');
   if (main) { main.src = thumb.dataset.icGallerySrc; main.removeAttribute('srcset'); main.alt = thumb.dataset.icGalleryAlt || ''; }
   document.querySelectorAll('[data-ic-gallery-src]').forEach(el => el.setAttribute('aria-pressed', String(el === thumb)));
  }
 });
 if (dialog) {
  dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
  dialog.addEventListener('close', () => root.classList.remove('ic-lock'));
 }
 const form = dialog?.querySelector('[data-ic-preorder-form]');
 if (form) {
  const email = form.querySelector('[name="email"]');
  const error = form.querySelector('.ic-form-error');
  const status = form.querySelector('[data-ic-status]');
  const submit = form.querySelector('[data-ic-submit]');
  const recovery = form.querySelector('[data-ic-checkout-recovery]');
  const recoveryLink = recovery.querySelector('a');
  const copy = window.introcardStoreCopy || {};
  const base = window.Shopify?.routes?.root || '/';
  let active = null;
  const reset = () => {
   if (active) { clearTimeout(active.timer); active.controller.abort(); active = null; }
   submit.disabled = false; submit.removeAttribute('aria-busy'); status.textContent = '';
  };
  const fail = (attempt, message) => {
   if (active !== attempt) return;
   recoveryLink.href = attempt.cartReady ? attempt.checkoutUrl.href : base + 'cart';
   recoveryLink.textContent = attempt.cartReady ? copy.checkoutFallback : copy.cartFallback;
   reset(); error.textContent = message; recovery.hidden = false;
  };
  async function request(path, body, attempt) {
   const response = await fetch(base + path, {
    method: body ? 'POST' : 'GET', credentials: 'same-origin', signal: attempt.controller.signal,
    headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) },
    ...(body ? { body: JSON.stringify(body) } : {})
   });
   if (!response.ok) throw new Error('Checkout request failed');
   return response.json();
  }
  window.addEventListener('pageshow', () => { reset(); recovery.hidden = true; error.textContent = ''; });
  window.addEventListener('pagehide', reset);
  dialog.addEventListener('close', reset);
  form.addEventListener('submit', async event => {
   event.preventDefault();
   if (active || !form.reportValidity()) return;
   const attempt = { controller: new AbortController(), cartReady: false, optin: form.querySelector('[name="marketing_opt_in"]').checked };
   active = attempt;
   submit.disabled = true; submit.setAttribute('aria-busy', 'true');
   error.textContent = ''; status.textContent = copy.opening || ''; recovery.hidden = true;
   attempt.timer = setTimeout(() => fail(attempt, attempt.cartReady && attempt.optin ? copy.signupError : copy.timeout), 15000);
   try {
    const variant = Number(dialog.dataset.variantId);
    if (!Number.isSafeInteger(variant) || variant < 1 || dialog.dataset.available !== 'true') {
     fail(attempt, copy.unavailable); return;
    }
    attempt.checkoutUrl = new URL(base + 'checkout', location.origin);
    const orderEmail = email.value.trim();
    attempt.checkoutUrl.searchParams.set('checkout[email]', orderEmail);
    const cart = await request('cart.js', undefined, attempt);
    if (active !== attempt) return;
    if (!cart.items.some(item => item.variant_id === variant)) {
     await request('cart/add.js', { items: [{ id: variant, quantity: 1, properties: { 'Pre-order': `${copy.dispatch || 'Expected dispatch'} ${dialog.dataset.dispatch}` } }] }, attempt);
    }
    if (active !== attempt) return;
    attempt.cartReady = true;
    if (!attempt.optin) { location.assign(attempt.checkoutUrl.href); return; }
    const signup = document.getElementById('ic-preorder-newsletter');
    if (!signup) throw new Error('Signup form unavailable');
    signup.querySelector('[name="contact[email]"]').value = orderEmail;
    signup.querySelector('[name="return_to"]').value = attempt.checkoutUrl.pathname + attempt.checkoutUrl.search;
    if (window.Shopify?.captcha?.protect) {
     window.Shopify.captcha.protect(signup, () => {
      if (active !== attempt) return;
      try { signup.submit(); } catch { fail(attempt, copy.signupError); }
     });
    } else signup.requestSubmit();
   } catch {
    fail(attempt, attempt.cartReady && attempt.optin ? copy.signupError : copy.error);
   }
  });
 }
 const signupError = dialog?.querySelector('[data-ic-optin-error]');
 if (signupError) { dialog.showModal(); root.classList.add('ic-lock'); signupError.setAttribute('tabindex', '-1'); signupError.focus(); }
 const bar = document.querySelector('[data-ic-preorder-bar]');
 if (bar) {
  // Establish the scroll position on the first scroll event without forcing initial layout.
  let previous = null;
  let direction = 0;
  let distance = 0;
  let pending = false;
  const update = () => {
   const current = Math.max(0, scrollPosition());
   if (previous === null) { previous = current; pending = false; return; }
   const delta = current - previous;
   const nextDirection = Math.sign(delta);
   if (nextDirection && nextDirection !== direction) { distance = 0; direction = nextDirection; }
   distance += Math.abs(delta);
   const footerTop = document.querySelector('.ic-footer')?.getBoundingClientRect().top ?? Infinity;
   const allowed = current > 600 && footerTop > innerHeight - 80 && !dialog?.open;
   if (!allowed || (direction > 0 && distance > 12)) {
    if (!bar.contains(document.activeElement)) bar.hidden = true;
   } else if (direction < 0 && distance > 32) bar.hidden = false;
   previous = current; pending = false;
  };
  scrollingSurface.addEventListener('scroll', () => { if (!pending) { pending = true; requestAnimationFrame(update); } }, { passive: true });
  bar.addEventListener('focusout', () => requestAnimationFrame(update));
  dialog?.addEventListener('close', () => { if (!bar.contains(document.activeElement)) bar.hidden = true; });
 }
 const stage = document.querySelector('[data-ic-tap-stage]');
 if (stage && !matchMedia('(prefers-reduced-motion: reduce)').matches && matchMedia('(min-width: 650px)').matches) {
  let pending = false;
  const update = () => { const rect = stage.getBoundingClientRect(); const progress = Math.max(0, Math.min(1, -rect.top / Math.max(rect.height, 1))); stage.style.setProperty('--ic-scroll', progress.toFixed(2)); pending = false; };
  scrollingSurface.addEventListener('scroll', () => { if (!pending) { pending = true; requestAnimationFrame(update); } }, { passive: true });
 }
})();
